import {
  FILTER_TREK,
  SET_LOADING_STATE,
  CLEAR_ALL_TREK_FILTER,
  ADD_TREK_FILTER_QUERY,
  REMOVE_TREK_FILTER_QUERY,
} from '../actions/types';
import omit from 'lodash/omit';

const filterTerm = {
  searchTerm: '',
  days: {
    min: 1,
    max: 30,
  },
  stars: '',
  price: {
    min: 0,
    max: 3000,
  },
  isGuided: false,
  region: '',
  trekType: '',
  month: '',
  query: {},
  loading: false,
};

export default (state = filterTerm, action) => {
  const { data, query, loading } = action;

  switch (action.type) {
    case FILTER_TREK:
      return { ...state, ...data };

    case CLEAR_ALL_TREK_FILTER:
      return { ...state, ...filterTerm };

    case ADD_TREK_FILTER_QUERY:
      return {
        ...state,
        query: {
          ...state.query,
          ...query,
        },
      };

    case REMOVE_TREK_FILTER_QUERY: {
      const filteredQuery = omit(state.query, query);
      return {
        ...state,
        query: filteredQuery,
      };
    }

    case SET_LOADING_STATE:
      return { ...state, loading };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/filterTreksReducer.js